module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs hide-small"
  }, [_c('div', {
    class: [_vm.tab === 'main' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.tab = 'main'
      }
    }
  }, [_vm._v("Main details")]), _vm._v(" "), (_vm.entity.id) ? _c('div', {
    class: [_vm.tab === 'items' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.tab = 'items'
      }
    }
  }, [_vm._v("Params")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tabs tabs-right hide-small"
  }, [_c('div', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-tab'],
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate))]), _vm._v(" "), _c('div', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-tab'],
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate) + " & exit")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show-small dropdown-admin-tabs"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.tab = 'main'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n          Main details\n          "), (_vm.tab === 'main') ? _c('i', {
    staticClass: "fa fa-check-square-o"
  }) : _vm._e()])]), _vm._v(" "), (_vm.entity.id) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.tab = 'items'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n          Params\n          "), (_vm.tab === 'items') ? _c('i', {
    staticClass: "fa fa-check-square-o"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-dropdown'],
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate))])]), _vm._v(" "), _c('li', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-dropdown'],
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate) + " and exit")])])])]), _vm._v(" "), _c('section', {
    staticClass: "clearfix",
    attrs: {
      "id": "main-content"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "admin-content",
      "id": "location-content"
    },
    slot: "admin-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab === 'items' && _vm.entity.id),
      expression: "tab === 'items' && entity.id"
    }]
  }, [(_vm.entity.id) ? _c('params', {
    attrs: {
      "parentId": _vm.entity.id,
      "filename": _vm.entity.filename
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.tab === 'main') ? _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-6 main-location-details left top-small"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "cur-code"
    }
  }, [_vm._v("Code *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.code),
      expression: "entity.code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "cur-code"
    },
    domProps: {
      "value": (_vm.entity.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "cur-name"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "cur-name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 main-location-details left bottom-small"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "bank"
    }
  }, [_vm._v("Filename *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.filename),
      expression: "entity.filename"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "bank"
    },
    domProps: {
      "value": (_vm.entity.filename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "filename", $event.target.value)
      }
    }
  })])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Options\n      "), _c('span', {
    staticClass: "caret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c0d7f8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Report/Report.vue
// module id = 2128
// module chunks = 1